export default function deprecate(msg: string) {
	// target: the prototype, or the class itself for a static member
	return function (target: object, propertyKey: string, descriptor: PropertyDescriptor) {
		if (!msg) {
			msg = 'Marked as deprecated';
		}

		let targetName = target.constructor.name;

		if (targetName === 'Function') {
			// static method
			targetName = (target as { name: string }).name;
		}

		let originalMethod: () => unknown;

		const deprecateFn = function (this: unknown, ...args: unknown[]) {
			const methodName = `${targetName}#${propertyKey}`;

			if (window.LOGIT) {
				// eslint-disable-next-line no-console
				console.warn(`Deprecation ${methodName}: ${msg}`);
				// console.trace();
			}
			return originalMethod.apply(this, args as []);
		};

		if (typeof descriptor.get === 'function') {
			// an accessor
			originalMethod = descriptor.get as () => unknown;
			descriptor.get = deprecateFn;
		} else if (typeof descriptor.value === 'function') {
			// a method
			originalMethod = descriptor.value as () => unknown;
			descriptor.value = deprecateFn;
		} else {
			throw new SyntaxError('Only functions or getters can be marked as deprecated');
		}

		return descriptor;
	};
}
